// export const jobCategoryPlans = [
//     {
//       planName: "Free Plan",
//       credits: "0.00",
//       duration: "10 days",
//       benefits: [
//         "Post 1 job listing",
//         "Basic visibility in job search results",
//         // "Access to a limited pool of job seekers",
//         "Basic applicant tracking features"
//       ]
//     },
//     {
//       planName: "Basic Plan",
//       credits: "10000",
//       duration: "30 days",
//       benefits: [
//         "Post 1 job listing",
//         "Basic visibility in job search results",
//         "Access to a limited pool of job seekers",
//         "Basic applicant tracking features"
//       ]
//     },
//     {
//       planName: "Standard Plan",
//       credits: "20000",
//       duration: "60 days",
//       benefits: [
//         "Post up to 3 job listings",
//         "Standard visibility in job search results",
//         "Access to a broader pool of job seekers",
//         "Enhanced applicant tracking features",
//         "Email support"
//       ]
//     },
//     {
//       planName: "Premium Plan",
//       credits: "30000",
//       duration: "90 days",
//       benefits: [
//         "Post up to 5 job listings",
//         "Premium visibility in job search results",
//         "Access to the entire job seeker database",
//         "Advanced applicant tracking features",
//         "Email and phone support",
//         "Company logo on job listings"
//       ]
//     },
//     {
//       planName: "Professional Plan",
//       credits: "40000",
//       duration: "6 months",
//       benefits: [
//         "Post up to 10 job listings",
//         "Featured visibility in job search results",
//         "Access to the entire job seeker database with advanced filters",
//         "Comprehensive applicant tracking features",
//         "Priority email and phone support",
//         "Company logo and profile on job listings",
//         "Analytics and reporting tools"
//       ]
//     },
//     {
//       planName: "Business Plan",
//       credits: "70000",
//       duration: "1 year",
//       benefits: [
//         "Post up to 20 job listings",
//         "Top-tier visibility in job search results",
//         "Access to the entire job seeker database with advanced filters and search capabilities",
//         "Full-featured applicant tracking system",
//         "Dedicated account manager",
//         "Company logo and profile on job listings",
//         "Detailed analytics and reporting tools",
//         "Free job post refreshes to keep listings at the top"
//       ]
//     },
//     {
//       planName: "Enterprise Plan",
//       credits: "120000",
//       duration: "1 year",
//       benefits: [
//         "Post up to 50 job listings",
//         "Premium placement in job search results",
//         "Unlimited access to the job seeker database with advanced filters and AI recommendations",
//         "Full-featured applicant tracking and team collaboration tools",
//         "Dedicated account manager and recruitment consultant",
//         "Company branding on job listings and employer page",
//         "Advanced analytics, reporting tools, and custom reports",
//         "Free job post refreshes and priority job post updates"
//       ]
//     },
//     {
//       planName: "Unlimited Plan",
//       credits: "200000",
//       duration: "1 year",
//       benefits: [
//         "Post unlimited job listings",
//         "Maximum visibility in job search results",
//         "Unlimited access to the job seeker database with advanced filters, AI recommendations, and direct messaging",
//         "Full-featured applicant tracking, team collaboration, and interview scheduling tools",
//         "Dedicated account manager and senior recruitment consultant",
//         "Premium company branding on job listings and employer page",
//         "Comprehensive analytics, reporting tools, and custom reports",
//         "Free job post refreshes and priority job post updates",
//         "Quarterly business reviews and strategy sessions"
//       ]
//     },
    
//   ];
  


// export const jobCategoryPlans = [
//   {
//     planName: "basic",
//     credits: "5000",
//     duration: "30 days",
//     benefits: [
//       "Post 1 job listing",
//       "Basic visibility in job search results",
//       "Basic applicant tracking features",
//     ],
//   },
//   {
//     planName: "standard",
//     credits: "50000",
//     duration: "60 days",
//     benefits: [
//       "Post up to 3 job listings",
//       "Standard visibility in job search results",
//       "Access to a broader pool of job seekers",
//       "Enhanced applicant tracking features",
//     ],
//   },
//   {
//     planName: "premium",
//     credits: "100000",
//     duration: "90 days",
//     benefits: [
//       "Post up to 5 job listings",
//       "Premium visibility in job search results",
//       "Access to the entire job seeker database",
//       "Advanced applicant tracking features",
//       "Company logo on job listings",
//     ],
//   },
//   {
//     planName: "partner with Ejobs",
//     credits: "150000",
//     duration: "180 days",
//     benefits: [
//       "Post up to 10 job listings",
//       "Top-tier visibility in job search results",
//       "Unlimited access to job seeker database",
//       "Full-featured applicant tracking",
//       "Dedicated support and branding",
//     ],
//   },
// ];



export const jobCategoryPlans = [
  // {
  //   planName: "Draft",
  //   credits: "0",
  //   duration: "N/A",
  //   benefits: [
  //     "Save job as draft",
  //     "No payment required",
  //     "Edit and submit later",
  //   ],
  // },
  {
    planName: "Basic",
    credits: "1000",
    duration: "24 hours",
    benefits: [
      "Post 1 job listing",
      "Visible for 24 hours after approval",
      "Basic visibility in job search results",
    ],
  },
  {
    planName: "Standard",
    credits: "5000",
    duration: "30 days",
    benefits: [
      "Post 1 job listing",
      "Visible for 30 days after approval",
      "Standard visibility in job search results",
  
    ],
  },
  {
    planName: "Premium",
    credits: "20000",
    duration: "30 days",
    benefits: [
      "Post 1 job listing",
      "Visible for 30 days after approval",
      "Premium visibility in job search results",
      "Advanced applicant sorting features",
      
    ],
  },
];